<div class="py-4 px-0">
  <div class="container">
    <h1>{{ "acceptance.title" | translate }}</h1>

    <app-terms-of-use></app-terms-of-use>

    <app-privacy-policy></app-privacy-policy>

    <form [formGroup]="acceptanceForm" (ngSubmit)="onSubmit()">
      <div class="form-group form-check">
        <input type="checkbox" class="form-check-input" id="acceptance" formControlName="acceptance" />
        <label class="form-check-label" for="acceptance">{{ "acceptance.acceptance" | translate }}</label>
      </div>

      <button type="submit" class="btn btn-blue" [disabled]="acceptanceForm.invalid">
        {{ "forms.common.save" | translate }}
      </button>
    </form>
  </div>
</div>
